const countriesWithCitiesAndTownships = [
  'China',
  'Myanmar',

  'India',
  'Thailand',
];

export default countriesWithCitiesAndTownships;
